import { createReduxContextStore } from 'src/researcher/context/store';
import { listStoreReducer, ListActions, LandingListStore } from './list.reducer';

export const {
  Provider: RecentTrashProjectStore,
  useState: useRecentTrashProjectState,
  useDispatch: useRecentTrashProjectDispatch,
} = createReduxContextStore<LandingListStore, ListActions>(listStoreReducer);
